import { FC, PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';
import { HelpCenterArticle } from './consts';
import { useUnifiedIntercomEnabled } from './UnifiedIntercom';
import { helpCenterArticleLink } from './util';

interface Props {
  article: HelpCenterArticle;
  className?: string;
}

const ArticleLink: FC<PropsWithChildren<Props>> = ({
  article,
  className = '',
  children,
}) => {
  const { locale } = useIntl();
  const unifiedIntercomEnabled = useUnifiedIntercomEnabled();

  return (
    <a
      className={className}
      target="_blank"
      rel="noopener noreferrer"
      href={helpCenterArticleLink(locale, article, unifiedIntercomEnabled)}
    >
      {children}
    </a>
  );
};

export default ArticleLink;
